import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';

import moment from 'moment';

import { AppLayoutTop } from 'components/appComponents';
import { Button, DataGrid } from 'devextreme-react';
import { useQuery } from 'utils/useQuery';

import { useLazyGetEmployeeDetailQuery } from 'bus/employee/services/services';
import { EmployeeItem } from 'bus/employee/types';
import { useLazyGetEmployeeSalaryDetailQuery } from 'bus/employeeSalary/services/services';

import { SalaryEmployeeInfoTable, SalaryEmployeeInfoTotals } from './components';
import { onExporting } from './utils';

const SalaryEmployeeInfo: FC = () => {
  const [getEmployeeSalaryDetail, { data }] = useLazyGetEmployeeSalaryDetailQuery();

  const refGridMain = useRef<DataGrid | null>(null);
  const refGridAdjustment = useRef<DataGrid | null>(null);

  let { id } = useParams<{ id: string }>();
  let query = useQuery();

  const [fetchEmployeeDetail] = useLazyGetEmployeeDetailQuery();

  const dateBegin = query.get('dateBegin');
  const dateEnd = query.get('dateEnd');

  const [formEmployee, setFormEmployee] = useState<EmployeeItem | null>(null);

  const fullName = `${formEmployee?.name} ${formEmployee?.middleName} ${formEmployee?.surname}`;
  const dateBeginText = moment(dateBegin).format('DD.MM.YYYY');
  const dateEndText = moment(dateEnd).format('DD.MM.YYYY');
  const date = `${dateBeginText} - ${dateEndText}`;

  const getEmployeeDetail = useCallback(async () => {
    await fetchEmployeeDetail({ id })
      .unwrap()
      .then((data) => {
        setFormEmployee({ ...data });
      });
  }, [fetchEmployeeDetail, id]);

  useEffect(() => {
    getEmployeeDetail();
  }, [getEmployeeDetail]);

  const salaryDataStore = useCallback(async () => {
    if (id) {
      await getEmployeeSalaryDetail({
        employeeId: +id,
        dateBegin: String(dateBegin),
        dateEnd: String(dateEnd),
      });
    }
  }, [dateBegin, dateEnd, getEmployeeSalaryDetail, id]);

  useEffect(() => {
    salaryDataStore();
  }, [salaryDataStore]);

  const exportGrids = () =>
    onExporting(refGridMain, refGridAdjustment, data!, fullName, {
      dateBeginText,
      dateEndText,
    });

  return (
    <div>
      <AppLayoutTop title={`${fullName} (${date})`}>
        <Button text="Экспорт в excel" icon="xlsxfile" onClick={exportGrids} />
      </AppLayoutTop>
      <SalaryEmployeeInfoTotals
        adjustments={data?.adjustments || 0}
        balance={data?.balance || 0}
        dateBegin={moment(dateBegin).format('DD.MM.YYYY') || ''}
        dateEnd={moment(dateEnd).format('DD.MM.YYYY') || ''}
        outBalance={data?.outBalance || 0}
        pay={data?.pay || 0}
        toPay={data?.toPay || 0}
      />

      <SalaryEmployeeInfoTable
        ref={refGridMain}
        dateBegin={String(dateBegin)}
        dateEnd={String(dateEnd)}
        employeeId={+id}
      />
    </div>
  );
};

export default SalaryEmployeeInfo;
